/* eslint-disable no-underscore-dangle */
const CONTENTSQUARE_ID = 'cae5a0f6523cc';

declare global {
  // eslint-disable-next-line no-var, vars-on-top
  var CS_CONF: string;
  // eslint-disable-next-line no-var, vars-on-top, no-underscore-dangle
  var _uxa: unknown[] | undefined;
}

const isTestEnv = (): boolean => global.getBasedOnEnvironment({ test: true, default: false });

function getWindowLocation() {
  return window.location.pathname + window.location.hash.replace('#', '?__');
}

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `contentSquare` namespace.
 */
export const handleStateChange = (): void => {
  if (isTestEnv()) {
    return;
  }

  /* First call */
  if (typeof global.CS_CONF === 'undefined' || !global._uxa) {
    global._uxa = global._uxa || [];
    global._uxa.push(['setPath', getWindowLocation()]);
    const mt = document.createElement('script');
    mt.type = 'text/javascript';
    mt.async = true;
    mt.src = `//t.contentsquare.net/uxa/${CONTENTSQUARE_ID}.js`;
    document.getElementsByTagName('head')[0].appendChild(mt);
  } else {
    /* Every next call */
    global._uxa.push(['trackPageview', getWindowLocation()]);
  }
};
